import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';

import { Tenant } from './tenant';

@Injectable()
export class TenantService {
  constructor(private tarlV3Jsonapi: TarlV3Jsonapi) {}

  getTenant(): Observable<Tenant> {
    const include = [
      'bookstores',
      'citation_styles',
      'importances',
      'licenses',
      'periods',
      'reports',
      'tags',
    ];
    return this.tarlV3Jsonapi.getResource<Tenant>('', { include });
  }
}
